module.exports = __webpack_public_path__ + "img/readingtask3passage.03d4f2e0.png";